import React from "react";
import { useTranslation } from "react-i18next";
import { Gift } from "lucide-react";
import { Button } from "@/components/ui/button";

interface RewardsOverviewSectionProps {
  credits: number;
  onConvert: () => void;
}

export const RewardsOverviewSection: React.FC<RewardsOverviewSectionProps> = ({
  credits,
  onConvert,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <h2 className="text-lg font-semibold text-text-primary dark:text-gray-100">
        {t("settings.rewards.title")}
      </h2>

      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between rounded-xl border border-border-secondary dark:border-gray-600 bg-bg-primary dark:bg-gray-800 p-4">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-indigo-50 dark:bg-indigo-900/30">
            <Gift className="h-5 w-5 text-indigo-500 dark:text-indigo-400" />
          </div>
          <div className="flex flex-col gap-0.5">
            <p className="text-sm font-medium text-text-quaternary dark:text-gray-400">
              {t("settings.rewards.totalCredits")}
            </p>
            <p className="text-2xl font-semibold text-text-primary dark:text-gray-100">
              {credits.toLocaleString()}
            </p>
          </div>
        </div>

        <Button
          type="button"
          variant="darkPrimary"
          onClick={onConvert}
          disabled={credits <= 0}
          className="px-4 py-2.5 rounded-[10px] disabled:opacity-50 disabled:cursor-not-allowed self-start sm:self-auto"
        >
          {t("settings.rewards.convert")}
        </Button>
      </div>
    </div>
  );
};
